"use strict";
import { __exports as r } from "./index.es321.js";
var _;
function i() {
  if (_) return r;
  _ = 1;
  function u(e) {
    return e && e.__esModule ? e : { default: e };
  }
  return r._ = u, r;
}
export {
  i as __require
};
//# sourceMappingURL=index.es287.js.map
